import React from 'react';
import {connect} from 'react-redux';
import styles from './css/Planning.styl';
import WhatsIncluded from './components/WhatsIncluded';
import PlanningSearchCTA from './components/PlanningSearchCTA';
import PlanAhead from './components/PlanAhead';
import Hero from './components/Hero';
import HeroAlternate from './components/Hero/alternate';

/**
 * Planning module
 * @class   Planning
 * @return  {JSX}     Returns the rendered module
 */
export class Planning extends React.Component {
  static propTypes = {
    ads: React.PropTypes.object.isRequired,
    location: React.PropTypes.object.isRequired,
    planning: React.PropTypes.object.isRequired,
  };

  /**
   * React Component render.
   * @return {JSX} Planning page rendered.
   */
  render() {
    const {guideVersion} = this.props.planning;

    return (
      <div className={styles.Planning}>
        <div className={styles.Content}>
          <div className={styles.Container}>
            {guideVersion === 2 ? <Hero /> : <HeroAlternate />}
            <PlanAhead />
            <WhatsIncluded />
            <PlanningSearchCTA />
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ads: state.adStore,
  planning: state.planningStore,
});

export default connect(mapStateToProps)(Planning);



// WEBPACK FOOTER //
// ./src/reactModules/pages/GeneralPlanning/index.js